import {
  Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  useToast,
} from '@chakra-ui/react';
import { useDeleteFormMutation } from '../../Services/apiSlice';

const DeleteFormModal = ({ isOpen, onClose, form }) => {
  const [deleteForm, { isLoading }] = useDeleteFormMutation();
  const toast = useToast();

  const handleDeleteForm = async () => {
    await deleteForm(form.id);
    toast({
      title: 'Form deleted',
      status: 'success',
      variant: 'left-accent',
      isClosable: true,
      position: 'top',
      duration: 3000,
    });
    onClose();
  };
  if (!isOpen || !form) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete form</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          Are you sure you want to delete the form
          {' '}
          <b>
            {form.name}
          </b>
          ? You won&apos;t be able to recover the form
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" colorScheme="blue" mr={3} onClick={handleDeleteForm} isLoading={isLoading}>
            Delete
          </Button>
          <Button variant="ghost" isDisabled={isLoading} onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteFormModal;
